import ShowAnyThing from "./Components/buttonUses";
import css from '../../pic/section-3/css.png'
import html from '../../pic/section-3/html.png'
import javaS from '../../pic/section-3/js.png'
import reduxIm from '../../pic/section-3/redux.png'
import reactIm from '../../pic/section-3/react.png'
import taill from '../../pic/section-3/taill.png'
import boot from '../../pic/section-3/boot.png'
import figma from '../../pic/section-3/figma.com.png'
import mongo from '../../pic/section-3/learning/mongo.png'
import node from '../../pic/section-3/learning/node.png'
import sql from '../../pic/section-3/learning/sql.png'
import GridPics from "./Components/gridPic";


export default function Skills(){
    const skills1 =
        [   
            {"pic":css , "name":"CSS"},
            {"pic":html , "name":"HTML"},   
            {"pic":javaS , "name":"JavaScript"},    
            {"pic":boot , "name":"Bootstrap"}
        ]
    const skills2 = [
        {"pic":reactIm , "name":"React.js"},
        {"pic":reduxIm , "name":"Redux"},   
        {"pic":taill , "name":"TailWind"},    
        {"pic":figma , "name":"Figma"}
    ]
    return(
        <div className="text-[#1F2937]" id="skills">
            <ShowAnyThing name={"SKILLS"}/>
            <div className="container flex flex-row w-full justify-center pb-10">
                <div className="xlg:w-1/2 md:w-3/4 w-full ps-4 lg:ps-0 md:ps-0">
                    <h2 className="font-semibold mt-24 text-3xl text-[#1F2937]">USING NOW :</h2>
                </div>
            </div>
            <GridPics grids={skills1} stylegrids={"pocket-anime"}/>
            <GridPics grids={skills2} stylegrids={"pocket-anime2"}/>
            <div className="container lg:flex md:flex hidden flex-row w-full justify-center pb-10">
                <div className="xlg:w-1/2 md:w-3/4 w-full">
                    <h2 className="font-semibold mt-24 text-3xl">LEARNING :</h2>
                </div>
            </div>
            <div className="container lg:flex md:flex hidden flex-row w-full justify-center xlg:ms-40 md:ms-20 ms-0 mt-10 pb-20">
                <div className="lg:w-3/4 md:w-full w-full grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 px-20 justify-around gap-10 mx-auto ">
                    
                    {/* Mongo */}
                    <div className="flex flex-col justify-center">
                        <img src={mongo} className="w-[120.21px] h-[100px] ps-3 mx-auto" alt="" />
                        <h3 className="text-center mx-auto mt-5 font-semibold text-3xl">Mongo DB</h3>
                    </div>
                    {/* SQL */}
                    <div className="flex flex-col justify-center">
                        <img src={sql} className="w-[120.21px] h-[100px] ps-3  mx-auto" alt="" />
                        <h3 className="text-center mx-auto mt-5 font-semibold text-3xl">SQL</h3>
                    </div>
                    {/* Node.js */}
                    <div className="flex flex-col justify-center">
                        <img src={node} className="w-[120.21px] h-[100px] ps-3  mx-auto" alt="" />
                        <h3 className="text-center mx-auto mt-5 font-semibold text-3xl">Node.js</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}